 
namespace TabAurous.Retail {
    import fld = POSQuotationBOMRow.Fields;
     @Serenity.Decorators.registerClass()
    export class POSQuotationBOMEditor extends _Ext.BOMGridEditor<POSQuotationBOMRow> { 
        protected getDialogType() { return POSQuotationBOMDialog; }
        protected getLocalTextPrefix() { return POSQuotationBOMRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSQuotationItemsDialog).CalculateTotals();
                }
            })

        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
         
         protected getButtons() {
             let buttons = super.getButtons();

             buttons.push({
                 title: "Select BOM",
                 cssClass: "add-button",
                 onClick: () => {

                     // **** Validate Party before Item Selection ****


                     var grid = Common.ProductSelectGrid;
                     var filters: _Ext.SelectGridFilters = {
                         FilterItems: 4
                     }

                     var pickerDialog = new _Ext.GridItemPickerDialog({
                         gridType: grid, multiple: true,
                         preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                     });
                     pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
                         selectedItems = selectedItems.filter(x => x != undefined);
                         let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.BOMAttributeId == t.AttributeId) });
                         var self = this;
                         var details = [];
                         let lineno;
                         // #region Items to Grid
                         //for (let value of selectedItems2)
                         selectedItems2.forEach(function (value: OMS.ProductMasterRow) {
                             var oldbom = value;
                             var bom: POSQuotationBOMRow = {
                                 ProductCode: oldbom.ProductCode,
                                 BOMProductId: oldbom.ProductId,
                                 BOMAttributeId: oldbom.AttributeId,
                                 CalcOnId: oldbom.CalcOnId,
                                 Pieces: oldbom.Pieces,
                                 Weight: oldbom.Weight,
                                 ItemType: oldbom.ItemType,
                                 ItemTypeId: oldbom.ItemTypeId,
                                 StoneColorId: oldbom.StoneColorId,
                                 Attribute: oldbom.Attribute,
                                 CategoryId: oldbom.CategoryId,
                                 SubCategoryId: oldbom.SubCategoryId,
                                 ProductTypeId: oldbom.ProductTypeId,
                                 QualityId: oldbom.QualityId,
                                 SieveId: oldbom.SieveId,
                                 ShapeId: oldbom.ShapeId,
                                 StoneSizeId: oldbom.StoneSizeId,
                                 SettingId: oldbom.SettingId,
                                 StoneCuletId: oldbom.StoneCuletId,
                                 StoneCutId: oldbom.StoneCutId,
                                 StoneFluorescenceId: oldbom.StoneFluorescenceId,
                                 StoneGirdleId: oldbom.StoneGirdleId,
                                 StonePolishId: oldbom.StonePolishId,
                                 StoneSymmetryId: oldbom.StoneSymmetryId,
                                 StoneDepth: oldbom.StoneDepth,
                                 StoneTable: oldbom.StoneTable,

                                 KaratId: oldbom.KaratId,
                                 MetalColorId: oldbom.MetalColorId,
                                 Purity: oldbom.Purity,
                                 PureWeight: oldbom.Purity * oldbom.Weight,
                             };

                             details.push(bom);


                             for (let Detail of details) {
                                 Detail[self.getIdProperty()] = "`" + self.nextId++;
                                 self.view.addItem(Detail);
                             }


                         });
                     }
                     pickerDialog.dialogOpen();

                 }
             });

             return buttons;
         } 
    }
}